<template>
  <footer aria-label="footer">
    <div class="footer_big">
      <div class="container">
        <div class="row">
          <div class="col-md-4 col-sm-4 col-xs-12 footer-brand-col">
            <router-link to="/" class="footer-logo-link">
              <img
                src="../assets/gws-logo-new.png"
                alt="Grow with stocks logo"
                class="footer-logo"
              >
            </router-link>
            <p class="footer-contact mt-4">
              <span class="footer-contact-item">
                <i class="fa fa-phone" aria-hidden="true"></i>
                <a href="tel:+919271212131">+91-9271212131</a>
              </span>
              <span class="footer-contact-item">
                <i class="fa fa-envelope" aria-hidden="true"></i>
                <a href="mailto:info@growwithstocks.com">info@growwithstocks.com</a>
              </span>
            </p>
            <ul class="inline_list" aria-label="Social media">
              <li>
                <a
                  target="_blank"
                  rel="noopener"
                  href="https://www.facebook.com/growwithstocks/"
                  aria-label="Grow With Stocks on Facebook (opens in new tab)"
                >
                  <i class="icon ml-2 fab fa-facebook" aria-hidden="true"></i>
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener"
                  href="https://www.instagram.com/growwithstocks/"
                  aria-label="Grow With Stocks on Instagram (opens in new tab)"
                >
                  <i class="icon ml-2 fab fa-instagram" aria-hidden="true"></i>
                </a>
              </li>
            </ul>
          </div>
          <div class="col-md-8 col-sm-8 px-3 mt-3 pull-right">
            <nav aria-label="Footer navigation">
            <ul class="inline_list footer-nav pull-right">
              <li class="ml-2"><router-link to="/about">About</router-link></li>
              <li class="ml-2"><router-link to="/#services">Services</router-link></li>
              <li class="ml-2"><router-link to="/#whyUs">Why Us ?</router-link></li>
              <li class="ml-2"><router-link to="/pricing">Pricing</router-link></li>
              <li class="ml-2"><router-link to="/faq">FAQ</router-link></li>
              <li class="ml-2"><router-link to="/contact">Contact</router-link></li>
              <li class="ml-2"><router-link to="/investor-charter">Investor Charter</router-link></li>
              <li class="ml-2"><router-link to="/investor-complaints">Investor Complaints</router-link></li>
              <li class="ml-2"><router-link to="/mandatory-disclosure">Mandatory Disclosure</router-link></li>
              <li class="ml-2"><router-link to="/grievance">Grievance</router-link></li>
              <li class="ml-2"><router-link to="/compliance-audit">Compliance Audit</router-link></li>
              <li class="ml-2"><router-link to="/conflicts-of-interest">Conflict Of Interest</router-link></li>
              <li class="ml-2"><router-link to="/anti-money-laundering-policy">Anti-Money Laundering Policy</router-link></li>
              <li class="ml-2"><router-link to="/terms-and-conditions">Terms and Conditions</router-link></li>
              <li class="ml-2"><router-link to="/valid-upi">Valid UPI</router-link></li>
              <li class="ml-2"><router-link to="/sitemap">Sitemap</router-link></li>
            </ul>
            </nav>
            <!-- <p class="copyright mt-3 pull-right">2018 © Grow With Stocks</p> -->
          </div>
        </div>
        <div
          class="row"
          id="footer_disclaimer"
        >
           <div class="ml-2 my-5">
               <p>
              <strong>
                PROPRIETOR GROW WITH STOCKS) GOUTAM SHARMA, Research Analyst
                <br/>
                </strong>
                SEBI (Research Analysts) Regulations 2014, Registration No. INH000001212
                <br>
                  <br>
                  120, SHASTRI NAGAR, BEHIND RAM MANDIR,
                  JAMMU, Jammu & Kashmir - 411006

                    <br>
                  <strong>
                     Telephone:
                  </strong>
                  +91-9271212131
                  <br>
                  <strong> Email: </strong> info@growwithstocks.com, growwithstocks@gmail.com 
                  <br>
                  <strong>Website:
                  </strong>
                  www.growwithstocks.com
                  <br>


                    <br>
                    <strong>

                      <i>
                        Grievance Officer: Mr Goutam Sharma
                      </i>
                    </strong>
                <br>
                Telephone: +91-9271212131 | Email: growwithstocks@gmail.com
              </p>
            </div>

          <div class="col-xs-12">
            <p>
              <strong>SCORES : <a href="https://scores.sebi.gov.in/" target="_blank" rel="noopener" class="external-link">
                https://scores.sebi.gov.in/
              </a>
              </strong>
              <br>
              Online Dispute Resolution Portal ("ODR Portal") per SEBI
              (Alternative Dispute Resolution Mechanism) (Amendment) Regulations, 2023 is available at <a href="https://smartodr.in" target="_blank" rel="noopener" class="external-link">
                https://smartodr.in
              </a>
            </p>
          </div>

          <div class="col-xs-12">
            <p>
              <strong>Legal Disclaimer : </strong>
              <br>
              Investment in securities market are subject to market risks. Read all the related documents carefully before investing.
              <br>
              <br>
              Registration granted by SEBI and certification from NISM in no way guarantee performance of the intermediary or provide any assurance of returns to investors.
              <br>
              <br>
              Grow With Stocks, Goutam Sharma bearing Registration No. INH000001212  is an  individual Research Analyst. Information herein should be regarded as a resource only and should be used at one's own risk. This is not an offer to sell or solicitation to buy any securities and  Grow With Stocks, Goutam Sharma will not be liable for any losses incurred or investment(s) made or decisions taken/or not taken based on the information provided herein. Information contained herein does not constitute personalized advice or a personal recommendation or take into account the particular investment objectives, financial situations, or needs of individual subscribers.
              <br>
              <br>
               All investments involve risk and the past performance of a security(equities), or
              financial product does not guarantee future results or returns. Keep in mind that
              while diversification may help spread risk it does not assure a profit, or protect
              against loss, in a down market. <router-link to="/disclaimer" class="read-more-link">Read more ...</router-link>
            </p>
          </div>

          <div class="col-xs-12 vigilance-block">
            <p>
              Vigilance Awareness Week 2025 is being observed from October 27th to November 2nd, 2025, with the theme:
            </p>
            <p class="vigilance-theme">
              <span lang="hi">सतर्कता: हमारी साझा जिम्मेदारी</span> <span class="vigilance-en">(&ldquo;Vigilance: Our Shared Responsibility&rdquo;)</span>
            </p>
            <p>
              All stakeholders are encouraged to participate in the e-pledge initiative by visiting the CVC portal: <a href="https://pledge.cvc.nic.in/" target="_blank" rel="noopener" class="external-link">https://pledge.cvc.nic.in/</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
  export default {
    name: "Footer",
    data() {
      return {
        showMore: false
      };
    }
  };
</script>

<style lang="scss" scoped>
  footer {
    .footer-brand-col {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }
    .footer-logo-link {
      display: inline-block;
      max-width: 100%;
    }
    .footer-logo {
      height: 65px;
      width: auto;
      max-width: 100%;
      max-height: 65px;
      object-fit: contain;
    }
    .footer-contact {
      margin-top: 16px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
      word-break: break-word;
      text-align: left;
    }
    .footer-contact-item {
      display: flex;
      align-items: flex-start;
      gap: 10px;
      flex-wrap: nowrap;
      text-align: left;
    }
    .footer-contact .fa,
    .footer-contact i {
      color: #000 !important;
      flex: 0 0 16px;
      width: 16px;
      text-align: center;
      line-height: 1.5;
      margin-top: 2px;
    }
    .footer-contact a {
      color: #1a7055;
      text-decoration: underline;
      overflow-wrap: anywhere;
      word-break: normal;
      min-width: 0;
      flex: 1 1 auto;
      line-height: 1.5;
    }
    border-top: 0.5px rgba(255, 255, 255, 0.5) solid;
    h1 {
      font-size: 36px;
      font-weight: 700;
      line-height: 42px;
      text-align: center;
    }
    p {
      font-size: 13px;
      font-weight: 400;
      line-height: 20px;
      span {
        color: rgba(255, 255, 255, 0.5);
      }
    }
    .copyright {
      color: #000;
    }
    h4 {
      font-weight: 400;
      font-size: 18px;
      line-height: 24px;
      margin-bottom: 30px;
    }
    .bdr_btm {
      padding-bottom: 10px;
      border-bottom: 1px #fff solid;
      margin-bottom: 10px;
    }
    color: rgba(0, 0, 0, 0.783);
    .inline_list {
      li {
        display: inline;
      }
      .icon {
        color: rgba(0, 0, 0, 0.783);
        font-size: 2em;
      }
    }
    /* WCAG 2.5.5/2.5.8 — touch target ≥ 44×44 for social icons */
    .inline_list[aria-label="Social media"] a {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-width: 44px;
      min-height: 44px;
      padding: 6px;
    }
    ul {
      list-style: none;
      margin-top: 12px;
      padding-left: 0px;
      li {
        cursor: pointer;
      }
    }
    .footer-nav a {
      color: #1a7055;
      text-decoration: none;
      display: inline-block;
      padding: 6px 4px;
      min-height: 36px;
      line-height: 24px;
      font-weight: 500;
    }
    .footer-nav a:hover,
    .footer-nav a:focus {
      color: #0d3d2e;
      text-decoration: underline;
    }
    .footer-nav a:focus-visible {
      outline: 3px solid #ffbf47;
      outline-offset: 2px;
    }
    .router-link-exact-active {
      border-bottom: none;
    }
    a:hover i,
    a:focus i {
      color: #0d3d2e !important;
    }
    a:focus-visible {
      outline: 3px solid #ffbf47;
      outline-offset: 2px;
    }
    .external-link {
      color: #1a7055;
      text-decoration: underline;
    }
    .external-link::after {
      /* Decorative external-link arrow: empty alt ("/ \"\"") so SR doesn't announce ↗ */
      content: " \2197" / "";
      font-size: 0.85em;
      margin-left: 2px;
    }
    .read-more-link {
      color: #0d3d2e;
      font-weight: 600;
      text-decoration: underline;
    }
    .read-more-link:hover,
    .read-more-link:focus {
      color: #062b1f;
      text-decoration: underline;
    }
    .read-more-link:focus-visible {
      outline: 3px solid #ffbf47;
      outline-offset: 2px;
    }
    .footer_small {
      background-color: #fafafa;
    }
    .footer_big {
      background: #f5f5f5;
    }
    .vigilance-block {
      margin-top: 16px;
      padding: 16px 20px;
      background: #ffffff;
      border-left: 4px solid #1a7055;
      border-radius: 4px;
    }
    .vigilance-block p {
      color: #1a1a1a; /* AAA on white */
      font-size: 14px;
      line-height: 22px;
      margin-bottom: 8px;
    }
    .vigilance-block p span {
      color: #1a1a1a; /* override the global "footer p span { color: rgba(255,255,255,.5) }" rule */
    }
    .vigilance-block p:last-child {
      margin-bottom: 0;
    }
    .vigilance-theme {
      font-size: 16px !important;
      font-weight: 700;
      color: #0d3d2e !important;
    }
    .vigilance-theme span[lang="hi"] {
      color: #0d3d2e !important;
      font-weight: 700;
    }
    .vigilance-theme .vigilance-en {
      font-weight: 500;
      color: #1a1a1a !important;
    }
    .vigilance-block a {
      color: #0d3d2e;
      font-weight: 600;
    }
  }
  /*==========  Mobile First Method  ==========*/

  /* Custom, iPhone Retina */
  @media only screen and (min-width: 320px) {
  }

  /* Extra Small Devices, Phones */
  @media only screen and (min-width: 480px) {
  }

  /* Small Devices, Tablets */
  @media only screen and (min-width: 768px) {
  }

  /* Medium Devices, Desktops */
  @media only screen and (min-width: 992px) {
  }

  /* Large Devices, Wide Screens */
  @media only screen and (min-width: 1200px) {
  }

  /*==========  Non-Mobile First Method  ==========*/

  /* Large Devices, Wide Screens */
  @media only screen and (max-width: 1200px) {
  }

  /* Medium Devices, Desktops */
  @media only screen and (max-width: 992px) {
  }

  /* Small Devices, Tablets */
  @media only screen and (max-width: 768px) {
  }

  /* Custom, iPhone Retina */

  @media screen and (max-width: 1024px) {
    footer p {
      margin-top: 0px;
    }
  }
  /* Small Devices, Tablets */
  @media only screen and (max-width: 768px) {
    footer .footer-brand-col {
      text-align: center;
      align-items: center;
      margin-bottom: 24px;
    }
    footer .footer-logo {
      height: 50px;
      max-height: 50px;
    }
    footer .footer-contact {
      align-items: flex-start;
      text-align: left;
    }
    footer .col-md-8.col-sm-8 {
      float: none !important;
      width: 100%;
    }
    footer .footer-nav {
      float: none !important;
      text-align: center;
    }
    footer .footer-nav li {
      display: inline-block;
      margin: 2px 4px !important;
    }
    ul {
      li {
        margin-left: 10px !important;
      }
    }
  }
  /* Extra Small Devices, Phones */
  @media only screen and (max-width: 480px) {
    footer .footer-logo {
      height: 44px;
      max-height: 44px;
    }
    footer .footer-contact {
      font-size: 12px;
    }
    #footer_disclaimer {
      margin-top: 30px;
    }
  }
  @media only screen and (max-width: 375px) {
    footer .footer-logo {
      height: 40px;
      max-height: 40px;
    }
    ul li {
      margin-left: 4px !important;
    }
  }
  @media only screen and (max-width: 320px) {
    footer .footer-logo {
      height: 36px;
      max-height: 36px;
    }
    ul li {
      font-size: 10px;
      margin-left: 8px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue